module.exports = __webpack_public_path__ + "img/banner-arrow.cd0f9eaa.svg";